// Store
import useProfileStore from '../../store/profileStore.js';

// Components
import { Slider } from '@mui/material';

// Style
import { grey } from '@mui/material/colors/index.js';
import { defaultColorScheme, tealColorScheme } from '../../styles/colorSchemes/index.js';

const CustomSlider = (props) => {
	const { colorScheme } = useProfileStore();

	let primaryColor = defaultColorScheme.primaryColor;
	let primaryColorLight = defaultColorScheme.primaryColorLight;
	if (colorScheme === 'teal') {
		primaryColor = tealColorScheme.primaryColor;
		primaryColorLight = tealColorScheme.primaryColorLight;
	}

	return (
		<Slider 
			{...props}
			sx={{
				...props.sx,
				'& .MuiSlider-thumb': { 
					color: primaryColorLight,
					width: 20,
					height: 20,
					'&:hover, &.Mui-focusVisible': {
						boxShadow: `0px 0px 0px 8px ${primaryColorLight}29`,
					},
					'&.Mui-active': {
						boxShadow: `0px 0px 0px 14px ${primaryColorLight}29`,
					},
					...props.sx?.['& .MuiSlider-thumb'],
				},
				'& .MuiSlider-track': { 
					color: primaryColorLight,
					...props.sx?.['& .MuiSlider-track'],
				},
				'& .MuiSlider-rail': { 
					color: primaryColorLight,
					...props.sx?.['& .MuiSlider-rail'],
				},
				'& .MuiSlider-mark': { 
					color: primaryColor,
					...props.sx?.['& .MuiSlider-mark'],
				},
				'& .MuiSlider-valueLabel': {
					lineHeight: 1, 
					fontSize: 14, 
					background: 'unset', 
					padding: 0, 
					width: 26, 
					height: 26, 
					borderRadius: '50% 50% 50% 0', 
					backgroundColor: grey[800], 
					transformOrigin: 'bottom left',
					transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
					'&:before': { display: 'none' },
					'&.MuiSlider-valueLabelOpen': { transform: 'translate(50%, -100%) rotate(-45deg) scale(1)' },
					'& > *': { transform: 'rotate(45deg)' },
					...props.sx?.['& .MuiSlider-valueLabel'],
				},
			}}
		/>
	);
};

export default CustomSlider;